import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import { Tooltip as ReactTooltip } from "react-tooltip";
import "./assets/style.css";
import { auth, db } from "./firebase";
import PasswordInput from "./PasswordInput";
import firebase from "firebase/compat/app";
import { Element, scroller } from "react-scroll";

const Chapter2_3 = () => {
  const navigate = useNavigate();
  const [selectedAnswers, setSelectedAnswers] = useState({ q1: "", q2: "" });
  const [error, setError] = useState("");
  const [userId, setUserId] = useState(null);
  const location = useLocation(); 
  const questions = [
    {
      question: "Frage 1: Welches Passwort ist sicherer?",
      options: [
        {
          value: "A",
          label: "Schalke04wirdMeister",
        },
        {
          value: "B",
          label: "utTmu5!12t",
        },
      ],
      correct: "B",
    },
    {
      question:
        "Frage 2: Warum ist es wichtig, für jedes Konto ein anderes Passwort zu verwenden?",
      options: [
        {
          value: "A",
          label:
            "Weil ein einziges kompromittiertes Passwort sonst Zugang zu mehreren Konten ermöglichen kann.",
        },
        {
          value: "B",
          label:
            "Weil Bankkonten andere Passwörter benötigen, als Mail-Accounts.",
        },
      ],
      correct: "A",
    },
  ];

  
  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        setUserId(user.uid); 
      } else {
        console.error("Kein authentifizierter Benutzer gefunden");
        setError("Benutzer ist nicht authentifiziert");
        navigate("/login"); 
      }
    });

   
    return () => unsubscribe();
  }, [navigate]);

 
  useEffect(() => {
    console.log("Aktuelle userId in 2_3.js:", userId);
  }, [userId]);

  const handleLogout = () => {
    
    auth
      .signOut()
      .then(() => {
        
        window.location.href = "/login"; 
      })
      .catch((error) => {
        console.error("Logout fehlgeschlagen:", error);
      });
  };

  const handleAnswerChange = (questionIndex, value) => {
    setSelectedAnswers((prev) => ({
      ...prev,
      [questionIndex]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const correctAnswers = questions.every(
      (q, index) => selectedAnswers[index] === q.correct
    );

    if (correctAnswers) {
      try {
        if (!userId) {
          console.error("userId ist nicht definiert");
          setError("Ein Fehler ist aufgetreten.");
          return;
        }

        const userDoc = await db.collection("users").doc(userId).get();

        console.log("userDoc:", userDoc.exists); 

        if (userDoc.exists) {
          
          await db
            .collection("users")
            .doc(userId)
            .update({
              lastChapter: "2_3",
              completedChapters:
                firebase.firestore.FieldValue.arrayUnion("2_3"),
            });
          console.log("Dokument aktualisiert mit Kapitel 2_3.");
        } else {
          
          await db
            .collection("users")
            .doc(userId)
            .set({
              lastChapter: "2_3",
              completedChapters: ["2_3"],
            });
          console.log("Dokument erstellt mit Kapitel 2_3.");
        }

        navigate("/2_4"); 
      } catch (error) {
        console.error("Fehler beim Aktualisieren des Fortschritts:", error);
        setError("Ein Fehler ist aufgetreten. Versuche es später erneut.");
      }
    } else {
      setError("Die Antworten sind nicht korrekt. Versuche es erneut.");
    }
  };

 
  useEffect(() => {
    if (location.hash) {
      scroller.scrollTo(location.hash.substring(1), {
        duration: 500,
        smooth: true,
        offset: -50,
      });
    }
  }, [location]);

  return (
    <div className="container">
      <div className="container py-5">
        <img
          src="/images/zebbs_Logo.svg"
          class="d-block mx-auto mb-4"
          alt=""
          style={{ width: "20%" }}
        />
        <div className="d-flex justify-content-between align-items-center mb-5 p-3 bg-body-tertiary rounded-3">
          {/* Breadcrumbs */}
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb breadcrumb-chevron mb-0">
              {/* Startseite (Home) */}
              <li className="breadcrumb-item">
                <Link className="link-body-emphasis" to="/course-overview">
                  <i className="bi bi-house-door-fill"></i>
                  <span className="visually-hidden">Home</span>
                </Link>
              </li>

              {/* Library Link */}
              <li className="breadcrumb-item">
                <Link
                  className="link-body-emphasis fw-semibold text-decoration-none"
                  to="/course-overview"
                >
                  2. Sicherheitslücken und Schwachstellen
                </Link>
              </li>

              {/* Aktuelle Seite */}
              <li className="breadcrumb-item active" aria-current="page">
                Passwortrichtlinien und Authentifizierung
              </li>
            </ol>
          </nav>

          {/* Logout-Button */}
          <button className="btn btn-outline-dark" onClick={handleLogout}>
            Logout
          </button>
        </div>

        <div
          className="px-5 pt-5 m-0 rounded-3"
          style={{
            position: "relative",
            backgroundColor: "#009fe0",
            margin: "25px",
            textAlign: "center",
          }}
        >
          <h3 className="text-center p-5">
            Kapitel 2: Sicherheitslücken und Schwachstellen
          </h3>
          <h2 className="text-center p-3">
            Passwortrichtlinien und Authentifizierung
          </h2>
          <img
            src="/images/authentication.webp"
            alt="Passwort"
            style={{ position: "relative", maxWidth: "35%", height: "auto" }}
          />
        </div>

        <div className="p-5 text-center">
          <h2 className="p-5">Passwortrichtlinien und Authentifizierung</h2>
          <p className="col-lg-11 mx-auto">
            Passwörter sind die am weitesten verbreitete Methode zur
            Authentifizierung. Unsichere oder schlecht verwaltete Passwörter
            können Angreifern den Zugriff auf Systeme und Daten erleichtern und
            sind dadurch eine häufige Schwachstelle.
            <br />
            <br />
            Effektive Passwortrichtlinien und starke Authentifizierungsverfahren
            stellen daher eine zentrale Anforderung der Cybersecurity dar. Die
            Herausforderung besteht darin, den Balanceakt zwischen Sicherheit
            und Benutzerfreundlichkeit zu schaffen, da zu komplexe
            Passwortrichtlinie die Akzeptanz bei den Nutzern beeinträchtigen
            könnten.
          </p>

          <p className="col-lg-11 mx-auto d-inline-flex p-5 m-5 text-decoration-none border-danger rounded-2">
            <img
              src="/images/fact.svg"
              alt="Transparent"
              style={{
                position: "relative",
                maxWidth: "8%",
                height: "auto",
              }}
            />
            Cybernews hat 56 Millionen Passwörter ausgewertet, die 2022 geknackt
            und veröffentlicht wurden. Wie zu erwarten sind die am häufigsten
            geknackten und damit unsichersten Passwörter "123456", "password",
            "qwerty" und "admin". Auf Platz eins liegt das Passwort "ass",
            welches alleine im Jahr 2022 292.9869 mal geknackt wurde.
          </p>
          <p className="col-lg-11 mx-auto">
            User nutzen oft kurze, einfache und unsichere Passwörter aus
            Bequemlichkeit und aus fehlendem Sicherheitsbewusstsein. „123456“
            oder „password“ sind einfach leichter zu behalten, besonders wenn
            ein Nutzer viele verschiedene Konten hat. Komplexe Passwörter dauern
            länger beim Tippen, insbesondere auf mobilen Geräten oder in
            stressigen Situationen. Wenn Websites zu viele Anforderungen stellen
            (z. B. mindestens 12 Zeichen, Groß- und Kleinbuchstaben, Zahlen,
            Sonderzeichen), fühlen sich Nutzer überfordert und greifen oft zu
            einfachen Mustern wie „Password123!“.
            <br />
            <br />
            Um dem entgegenzuwirken, sollten Plattformen und Unternehmen die
            Nutzung sicherer Passwörter durch einfache und praktische Methoden
            wie <strong> Passwortrichtlinien </strong> und
            <strong> Multi-Faktor-Authentifizierung (MFA) </strong>
            fördern. Gleichzeitig können Schulungen und Aufklärung dazu
            beitragen, das Sicherheitsbewusstsein der Nutzer zu verbessern.
          </p>
        </div>
      </div>

      <div className="gelb-section">
        <div className="container pb-5">
          <div className="p-5 text-center">
            <h2 className="p-5">Passwortrichtlinien</h2>
            <p className="col-lg-11 mx-auto">
              Eine gute Passwortrichtlinie beginnt mit der Erstellung von
              starken, einzigartigen Passwörtern, die schwer zu erraten sind.
              Einfache Passwörter wie "Schalke04", die sich der User leicht
              merken kann, bietet kaum Schutz, da sie von Angreifern leicht zu
              knacken sind, entweder durch Brute-Force-Angriffe, bei denen
              Hacker alle möglichen Zeichenkombinationen ausprobieren, oder
              durch sogenannte "Wörterbuch-Angriffe", bei denen häufig
              verwendete Passwörter ausprobiert werden (und in denen "Schalke04"
              sehr wahrscheinlich aufgeführt ist).
            </p>
            <h4 className="p-5">
              Zentrale Aspekte für ein sicheres Passwort sind:
            </h4>
            <p className="col-lg-10 text-start mx-auto">
              <ul>
                <li>
                  <strong>Komplexität: </strong>Bisher wurde empfohlen,
                  Passwörter mit einer Mischung aus Groß- und Kleinbuchstaben,
                  Zahlen und Sonderzeichen zu erstellen. Neuere Richtlinien
                  legen jedoch mehr Wert auf Länge als auf Komplexität.
                </li>{" "}
                <br />
                <li>
                  <strong>Länge: </strong>Längere Passwörter sind generell
                  sicherer. Ein Minimum von 8-12 Zeichen wird oft empfohlen.
                  Längere Passwörter sind noch besser. Wiederholungen oder
                  aufeinanderfolgende Zeichen sollten vermieden werden, da sie
                  die Komplexität eines Passworts erheblich reduzieren.
                  <br />
                </li>{" "}
                <br />
                <li>
                  <strong>Einzigartigkeit: </strong>Jedes Konto sollte ein
                  eigenes, einzigartiges Passwort haben, um das Risiko zu
                  minimieren, dass ein kompromittiertes Passwort mehrere Konten
                  gefährdet.
                  <br />
                </li>{" "}
                <br />
                <li>
                  <strong>Vermeidung persönlicher Informationen: </strong>
                  Passwörter sollten keine persönlichen Informationen wie
                  Geburtsdaten oder Namen enthalten. Diese Informationen können
                  leicht erraten oder über Social Media herausgefunden werden.
                  <br />
                </li>{" "}
                <br />
                <li>
                  <strong>Regelmäßige Änderungen: </strong>Die Praxis,
                  Passwörter in festen Intervallen zu ändern, wird zunehmend in
                  Frage gestellt, da sie oft zu schwächeren Passwörtern führt.
                  Stattdessen wird empfohlen, Passwörter nur bei Verdacht auf
                  Kompromittierung zu ändern. Dies verringert das Risiko, dass
                  gestohlene Passwörter über längere Zeit missbraucht werden.
                </li>{" "}
                <br />
                <li>
                  <strong>Vermeidung persönlicher Informationen: </strong>
                  Passwörter sollten keine persönlichen Informationen wie
                  Geburtsdaten oder Namen enthalten. Diese Informationen können
                  leicht erraten oder über Social Media herausgefunden werden.
                </li>{" "}
                <br />
              </ul>
            </p>
            <p className="col-lg-11 mx-auto">
              Jeder sollte regelmäßig überprüfen, ob die eigene E-Mail-Adresse
              und damit auch sein Passwort bereits bei einem Datenleck
              aufgetaucht ist: <br />
              Die Website{" "}
              <Link
                to="https://haveibeenpwned.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="custom-link"
              >
                &#8594; Have I Been Pwned?{" "}
              </Link>
              ist eine der bekanntesten und am häufigsten dafür genutzten
              Websites. Gib deine E-Mail-Adresse ein und die Website zeigt dir,
              ob deine Daten in einer der bekannten Datenbanken mit gestohlenen
              Informationen auftauchen.
              <br />
              <br />
              Es ist nicht leicht, all diese Richtlinien einzuhalten und sich
              alle Passwörter zu merken. Daher wird die Einrichtung eines{" "}
              <strong>Passwort-Managers </strong> empfohlen. Ein
              Passwort-Manager hilft dabei, sichere und komplexe Passwörter für
              jedes Konto zu erstellen und sicher zu speichern, sodass man sich
              nur ein Master-Passwort merken muss. Viele Nutzer wissen nicht,
              wie Passwort-Manager funktionieren, oder vertrauen ihnen nicht.
              Ohne solche Tools ist es aber sehr schwierig, komplexe und
              unterschiedliche Passwörter zu verwalten.
            </p>
            <p className="col-lg-8 mx-auto p-5">
              <strong>Passwort-Cracking-Time</strong>
              <br />
              Dieses Tool zeigt, wie stark sich die Sicherheit eines Passworts allein durch seine Länge verändert. Mit jedem zusätzlichen Zeichen steigt die Anzahl möglicher Kombinationen exponentiell an. Schon ein einziges weiteres Zeichen kann die Anzahl möglicher Varianten um ein Vielfaches erhöhen – und macht ein Passwort dadurch deutlich schwerer zu erraten. Probiere auch aus, was sich verändert, wenn zusätzlich noch Groß- und Kleinbuchstaben, Zahlen oder Sonderzeichen hinzukommen.
              <br /> <br />
              <PasswordInput />
            </p>
          </div>

          <p className="col-lg-9 mx-auto d-inline-flex p-5 m-5 text-decoration-none border-beispiel rounded-2">
            <img
              src="/images/attack.svg"
              alt="Angriff"
              style={{
                position: "relative",
                maxWidth: "10%",
                height: "auto",
              }}
            />
            In den 1960er Jahren, während des Kalten Krieges, war die Sicherheit
            von Atomwaffen ein großes Thema. In verschiedenen Medien wird
            berichtet, dass eine Zeit lang das Passwort um einen Atomangriff
            auszulösen, erschreckend einfach war: „11111111“. Es wurde angeblich
            so eingestellt, weil die Verantwortlichen sicherstellen wollten,
            dass es im Notfall einfach und schnell zu merken war. Die
            Vorstellung, dass eines der wichtigsten Passwörter der Welt so
            simpel gewesen sein könnte, ist heute kaum zu glauben.
          </p>
        </div>
      </div>
      <div className="white-section">
        <div className="container p-5">
          <div className="p-5 text-center">
            <h2 className="p-5">Multi-Faktor-Authentifizierung (MFA)</h2>
            <Element name="mfa">
              <p className="col-lg-11 mx-auto">
                Im Gegensatz zur herkömmlichen Authentifizierung mit nur einem
                Passwort, setzt die Multi-Faktor-Authentifizierung MFA auf eine
                zusätzliche Sicherheitsebene, um den Schutz vor unbefugtem
                Zugriff zu erhöhen. Die Idee hinter MFA ist, dass selbst wenn
                ein Angreifer ein Passwort stiehlt, er den zweiten
                Authentifizierungsfaktor benötigt, um Zugang zu erhalten.
                <br />
                <br />
                Bei der MFA müssen Benutzer ihre Identität durch mindestens zwei
                aus drei möglichen Kategorien nachweisen:
              </p>
              <p className="col-lg-9 mx-auto text-start">
                <strong> Wissen (etwas, das du weißt): </strong> Dies umfasst
                Dinge wie Passwörter, PINs oder Antworten auf Sicherheitsfragen.
                <br />
                <br />
                <strong>Haben (etwas, das du hast):</strong> Zum Beispiel ein
                Smartphone für Einmal-Passcodes oder ein Sicherheitstoken.
                <br />
                <br />
                <strong>Sein (etwas, das du bist):</strong> Biometrische Daten
                wie Fingerabdrücke, Gesichtserkennung oder Iris-Scans.
                Allerdings bieten die Gesichtserkennung oder Spracherkennung
                seit der immer besser werdenden Deep-Fake-Technologien keine
                große Sicherheit mehr, wie vor KI.
                <br />
              </p>
              <p className="col-lg-11 mx-auto">
                Beim Einloggen muss der Nutzer zwei oder mehr dieser Faktoren
                nachweisen. Beispiele sind das Bankkonto, das beim Login neben
                dem Passwort einen Einmalcode (TAN) verlangt,
                Social-Media-Konten, die eine SMS mit einem Bestätigungscode
                senden oder Unternehmenssysteme, die neben einem Passwort einen
                Fingerabdruck-Scan verlangen.
                <br />
                <br />
                MFA ist eine der effektivsten Methoden, um den Schutz sensibler
                Daten zu verbessern. Durch die Kombination mehrerer Faktoren
                wird es Angreifern wesentlich schwerer gemacht, unbefugt auf
                Systeme oder Konten zuzugreifen. Viele Unternehmen und Dienste
                setzen deshalb zunehmend auf MFA, um ihre Nutzer besser zu
                schützen.
                <br />
                <br />
                Obwohl MFA eine effektive Methode ist, um die Sicherheit von
                Konten zu verbessern, gibt es auch Herausforderungen bei der
                Implementierung. Eine der größten Hürden ist die{" "}
                <strong> Benutzerakzeptanz. </strong> Einige Benutzer empfinden
                MFA als umständlich oder zu zeitaufwendig, da es zusätzliche
                Schritte erfordert, um sich bei einem Dienst anzumelden. Zudem
                müssen Benutzer immer Zugriff auf ihren zweiten
                Authentifizierungsfaktor haben, was problematisch sein kann,
                wenn sie beispielsweise ihr Smartphone verlieren oder es defekt
                ist.
                <br />
                <br />
                Ein weiterer Aspekt sind die <strong> Kosten. </strong>{" "}
                Unternehmen, die MFA einführen, müssen in zusätzliche
                Technologien investieren, wie etwa biometrische Scanner,
                Sicherheits-Token oder Authentifizierungs-Apps. Auch die Wartung
                und der Support dieser Systeme stellen eine zusätzliche
                Belastung für die IT-Abteilungen dar.
              </p>
            </Element>
            <p className="col-lg-11 mx-auto d-inline-flex p-5 m-5 text-decoration-none border-beispiel rounded-2">
              <img
                src="/images/attack.svg"
                alt="Angriff"
                style={{
                  position: "relative",
                  maxWidth: "10%",
                  height: "auto",
                }}
              />
              Der britische Politiker Owen Smith veröffentlichte versehentlich
              ein Foto von seinem Homeoffice auf Twitter. Auf dem Foto war
              jedoch im Hintergrund ein Whiteboard zu sehen, auf dem bei
              ausreichender Vergrößerung eine URL, eine ID, ein Nutzername und
              ein Passwort zu lesen war. Es war der Zugang zu einer
              Regierungsseite. Der Vorfall führte nicht nur zu einer Menge
              Spott, sondern auch zu einer dringenden Sicherheitsüberprüfung.
            </p>
          </div>
        </div>
      </div>

      <div className="container mt-5">
        <div
          className="safe rounded-2 text-center"
          style={{ backgroundColor: "#fec748" }}
        >
          <img
            src="/images/abwehr.svg"
            alt="Abwehr"
            style={{
              position: "relative",
              maxWidth: "7%",
              height: "auto",
            }}
          />
          <Element name="brute">
            <h2 className="p-4">Brute-Force-Angriffe</h2>
            <p className="col-lg-11 mx-auto">
              Bei einem Brute-Force-Angriff versuchen Angreifer, Passwörter oder
              Schlüssel zu knacken, indem sie systematisch jede mögliche
              Kombination ausprobieren. Der Begriff "Brute-Force", übersetzt
              "rohe Gewalt", bezieht sich auf die unnachgiebige und direkte Art,
              ein Ziel zu erreichen ohne Rücksicht auf Intelligenz oder
              Effizienz. Dieser Angriffstyp gehört zu den ältesten und
              einfachsten Angriffstechniken. Er benötigt keine besonderen
              Schwachstellen im System, sondern nur Zeit und Rechnerleistung, um
              Erfolg zu haben.
              <br />
              <br />
              Es gibt verschiedene Arten von Brute-Force-Angriffen, wie den
              klassischen Brute-Force-Angriff, bei dem alle möglichen
              Kombinationen von Zeichen durchprobiert werden oder den{" "}
              <strong>
                {" "}
                <span
                  data-tooltip-id="tooltip-wort"
                  data-tooltip-content="Ein Wörterbuchangriff ist eine Methode, bei der Angreifer eine Liste häufig verwendeter Passwörter oder Wörter aus einem Wörterbuch verwenden, um Zugang zu einem System zu erhalten. Dabei werden systematisch alle Begriffe aus der Liste ausprobiert, bis das richtige Passwort gefunden wird. Diese Angriffsmethode ist besonders erfolgreich, wenn schwache oder leicht zu erratende Passwörter verwendet werden."
                  className="custom-tooltip-trigger"
                >
                  {" "}
                  Wörterbuchangriff,{" "}
                </span>{" "}
              </strong>{" "}
              bei dem bekannte Passwörter oder gängige Kombinationen zuerst
              ausprobiert werden. Obwohl diese Angriffe simpel erscheinen,
              können sie in der Praxis sehr effektiv sein, insbesondere bei
              schwachen Passwortrichtlinien oder unzureichenden
              Sicherheitsvorkehrungen.
              <br />
              <br />
              Es gibt bereits{" "}
              <strong>KI-beschleunigte Passwortknacker-Tools</strong>, die
              maschinelles Lernen einsetzen, um Passwort-Knacken effizienter zu
              gestalten. Diese Tools analysieren riesige Datensätze mit
              durchgesickerten Passwörtern und nutzen die Muster, um die
              Passwörter schneller zu erraten. Außerdem analysiert KI mit Hilfe
              von Deep Learning Daten über fehlgeschlagene Login-Versuche, die
              Angriffsmethoden und das Verhalten von Authentifizierungssystemen,
              um dann die Angriffe anzupassen.
            </p>
            <ReactTooltip
              id="tooltip-wort"
              place="top"
              className="custom-tooltip"
            />
            <h4 className="pt-5 pb-4">
              Wie kann man sich vor Brute-Force-Angriffen schützen?
            </h4>
            <p className="col-lg-11 mx-auto">
              Da Brute-Force-Angriffe oft auf schwache Passwörter oder
              ungeschützte Anmeldeprozesse abzielen, liegt der Schlüssel zur
              Prävention in der Kombination von{" "}
              <strong> langen und komplexen Passwörtern</strong> und der
              Aktivierung von <strong> Multi-Faktor-Authentifizierung. </strong>
              <br />
              <br />
              Anwendungen (Programme, Plattformen und Apps) sollten bereits bei
              der Entwicklung die sonst endlosen{" "}
              <strong>Anmeldeversuche begrenzen </strong> und das Konto oder den
              Benutzer temporär sperren. <br />
              <br />
              Auch
              <strong> CAPTCHA-Abfragen </strong> (Completely Automated Public
              Turing test to tell Computers and Humans Apart) können verhindern,
              dass automatisierte Brute-Force-Tools Anmeldeversuche durchführen.
              Captchas stellen Aufgaben (z. B. Bilder identifizieren oder
              Texteingaben), die nur Menschen lösen können und hindern
              automatisierte Bots daran, die Anmeldeseite zu nutzen.
            </p>

            <p className="col-lg-9 mx-auto d-inline-flex p-5 m-5 text-decoration-none border-danger rounded-2">
              <img
                src="/images/fact.svg"
                alt="Transparent"
                style={{
                  position: "relative",
                  maxWidth: "8%",
                  height: "auto",
                }}
              />
              Quantencomputer könnten bestimmte Verschlüsselungsverfahren schneller angreifen, weil sie Informationen anders verarbeiten als klassische Computer. Während normale Computer Rechenschritte nacheinander ausführen, können Quantencomputer durch quantenmechanische Effekte viele Möglichkeiten gleichzeitig berücksichtigen und bestimmte mathematische Probleme dadurch deutlich schneller lösen.
          Das bedeutet jedoch nicht, dass Quantencomputer alle Passwörter sofort knacken können – lange, zufällige Passwörter gelten weiterhin als vergleichsweise sicher. Leistungsfähige Quantencomputer existieren derzeit noch nicht in praxistauglicher Form, dennoch wird bereits an neuer, sogenannter „post-quanten­sicherer“ Verschlüsselung gearbeitet, um auf zukünftige Entwicklungen vorbereitet zu sein.
            </p>
          </Element>
        </div>
      </div>

      {/* Fragenteil */}
      <div className="container pt-5 my-5">
        <div className="text-center m-4">
          <h2>Überprüfe dein Wissen</h2>
          <p className="col-lg-11 mx-auto">
            Mit den richtigen Antworten kommst du weiter!
          </p>
        </div>
        <div className="row justify-content-center">
          <div className="col-md-9 text-start">
            <form onSubmit={handleSubmit}>
              {questions.map((question, index) => (
                <div key={index} className="mb-4">
                  <p className="fs-4">{question.question}</p>{" "}
                  {question.options.map((option) => (
                    <div key={option.value} className="form-check">
                      <input
                        className="form-check-input me-2"
                        type="radio"
                        name={`question${index}`}
                        value={option.value}
                        checked={selectedAnswers[index] === option.value}
                        onChange={() => handleAnswerChange(index, option.value)}
                      />
                      <label className="form-check-label fs-5">
                        {option.label}
                      </label>{" "}
                    </div>
                  ))}
                </div>
              ))}
              {error && <p className="text-danger">{error}</p>}
              <div className="text-center">
                <button type="submit" className="btn btn-primary">
                  überprüfen
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      {/* Ende Fragenteil */}
    </div>
  );
};

export default Chapter2_3;
